import recebiveisRouter from '../recebiveis/router';
import contaPagarRouter from '../contasPagar/router';
import carneRapidoRouter from '../carneRapido/router';

const router = [
  {
    path: '/financeiroConta/',
    name: 'financeiroConta',
    title: 'financeiroConta',
    component: () => import('../views/FinanceiroContaView.vue'),
    redirect: { name: 'financeiroConta-listar' },
    children: [...recebiveisRouter, ...contaPagarRouter, ...carneRapidoRouter],
  },
];

export default router;
